var exports = {
  "kL": "x112a1f60--af3346--container",
  "Sl": "x112a1f60--af3346--image",
  "wm": "x112a1f60--af3346--logo",
  "ne": "x112a1f60--af3346--controls",
  "h_": "x112a1f60--af3346--description",
};

module.exports = exports;
